const footerLinks = [
  { label: '快速上手', href: '#quickstart' },
  { label: '话题标签', href: '#tags' },
  { label: '使用教程', href: '#tutorials' },
  { label: '常见问题', href: '#faq' },
  { label: '反馈说明', href: '#feedback' },
];

const footerTags = ['黑料导航怎么用', '使用教程', '常见问题', '帮助中心', '标签筛选', '反馈说明', '新手指引', '移动端适配'];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-compass-3-line text-xl"></i>
              </span>
              <span className="font-heading text-xl tracking-wide text-foreground-950">黑料导航</span>
            </div>
            <p className="mt-4 text-sm text-foreground-700 leading-relaxed max-w-md">
              黑料导航提供使用教程和帮助说明，解答常见问题，支持反馈，教你快速上手，轻松找到黑料入口。遇到问题可随时查看帮助中心，详细步骤一目了然。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 rounded-md bg-background-50 border border-secondary-200 text-foreground-700 flex items-center justify-center cursor-pointer hover:text-primary-600 transition-colors">
                <i className="ri-mail-line"></i>
              </span>
              <span className="w-9 h-9 rounded-md bg-background-50 border border-secondary-200 text-foreground-700 flex items-center justify-center cursor-pointer hover:text-primary-600 transition-colors">
                <i className="ri-customer-service-2-line"></i>
              </span>
              <span className="w-9 h-9 rounded-md bg-background-50 border border-secondary-200 text-foreground-700 flex items-center justify-center cursor-pointer hover:text-primary-600 transition-colors">
                <i className="ri-bookmark-line"></i>
              </span>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-base text-foreground-950">页面导航</h3>
            <ul className="mt-4 space-y-3">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer inline-flex items-center gap-1.5"
                  >
                    <i className="ri-arrow-right-s-line"></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h3 className="font-heading text-base text-foreground-950">相关话题</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {footerTags.map((tag) => (
                <a
                  key={tag}
                  href="#tags"
                  className="px-3 py-1.5 rounded-full bg-background-50 border border-secondary-200 text-xs text-foreground-600 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {tag}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 text-center sm:text-left">
            © 2026 黑料导航 · 本站内容仅用于使用说明与帮助展示
          </p>
          <p className="text-xs text-foreground-500 flex items-center gap-1.5">
            <i className="ri-shield-check-line"></i>
            请留意使用规范与安全提示
          </p>
        </div>
      </div>
    </footer>
  );
}